if (document.getElementById('vue-faq')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: [ '[[', ']]' ],
		mixins: [ baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin ],
		el: '#vue-faq',
		data: {
			faqList: [],
			searchValue: '',
			selectedCategory: ''
		},
		computed: {
			hasResults() {
				return this.faqList.length;
			}
		},
		watch: {
			searchValue: {
				immidiate: true,
				handler: debounce(function() {
					this.search();
				}, 300)
			},
			selectedCategory() {
				this.getQuestions();
			}
		},
		mounted() {
			this.getQuestions();
		},
		methods: {
			getQuestions() {
				this.get('questions', { sites: window.site_id, id: this.selectedCategory }, false)
					.then((response) => {
						this.faqList = response.data.results;
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			search() {
				this.get('questions', { sites: window.site_id, search: this.searchValue, id: this.selectedCategory })
					.then((response) => {
						this.faqList = response.data.results;
						if (this.searchValue !== '') {
							this.faqList.forEach((el) => {
								el.children_obj.forEach((child) => {
									this.toggleOpen(child);
								});
							});
						}
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			toggleOpen(el) {
				Vue.set(el, 'isOpen', !el.isOpen);
			}
		}
	});
}
